// import angular from 'angular';

/* eslint-disable */
export default function EmergencyProcedureController(
  $filter,
  $q,
  $scope,
  bcpDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  editCustomTestingProceduresDialog
) {
  const vm = this;
  vm.filterHtml = _filterHtml;

  function _filterHtml(a){
    if(a) {
      return a.replace(/(<([^>]+)>)/ig, '').replace(/&nbsp;/gi,'');
    }
  }
}

EmergencyProcedureController.$inject = [
  '$filter',
  '$q',
  '$scope',
  'bcpDataService',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'userService',
  'editCustomTestingProceduresDialog'
];
